const api_url = process.env.VUE_APP_API_URL;

export default {
  url: api_url,
  uploadyml: partner_id => `${api_url}/goods-import/${partner_id}`,
  login: api_url + "/auth/login",
  restore: api_url + "/auth/restore",
  code: api_url + "/auth/code",
  users: api_url + "/users",
  usertypes: api_url + "/usertypes",
  partners: api_url + "/partners",
  categories: api_url + "/goodscategories",
  goods: partner_id => `${api_url}/partners/${partner_id}/goods`,
  moveGoods: partner_id =>
    `${api_url}/partners/${partner_id}/goods-mass/bind-products-to-category`,
  deleteGoods: partner_id =>
    `${api_url}/partners/${partner_id}/goods-mass/delete`,
  token: partner_id => `${api_url}/partners/${partner_id}/token`,
  statistic: partner_id => `${api_url}/partners/${partner_id}/statistics`,
  usersettings: api_url + "/usersettings",
  settings: api_url + "/settings",
  log: api_url + "/log",
  points: api_url + "/points-test",
  pointsGoods: api_url + "/goods-test",
  report: api_url + "/stat/info"
};
